<template>
    <div
        class="input-table"
        v-if="items.length"
    >
        <div
            class="input-table-shadow"
            v-for="(traveler, index) in items"
            :key="index"
        >
            <div class="d-flex row align-items-center">
                <div class="col-4 border-right">
                    <input class="pl-3" type="text" readonly="readonly" :value="travelerInfo(traveler)" />
                </div>
                <div class="col-4 border-right">
                    <reservation-details-travelers-placement
                        :traveler="traveler"
                        :selectedValue="getTravelerRoomType(traveler)"
                        :placements="placements"
                        @selected="setTravelerRoomType"
                    ></reservation-details-travelers-placement>
                </div>
                <div class="col-4">
                    <reservation-details-travelers-room
                        :key="roomsKey + getTravelerRoomType(traveler)"
                        :traveler="traveler"
                        :selectedValue="getTravelerRoom(traveler)"
                        :rooms="getSelectedPlacementRoom(traveler)"
                        @selected="setTravelerRoom"
                    ></reservation-details-travelers-room>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    travelers: {
      type: Array,
      required: true
    },
    serviceId: {
      type: String | Number,
      required: true
    },
    reservationLineId: {
      type: String | Number,
      required: false
    },
    placements: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      items: this.travelers,
      noneLabel: '- none -',
      coupes: [],
      roomsKey: 0
    }
  },
  methods: {
    reloadRoomsKey () {
      this.roomsKey += 1
    },
    getTravelerRoomType (traveler) {
      let room = this.$_.find(traveler.placements, {'serviceId': parseInt(this.serviceId)})
      if (room) {
        return room.rooms[0].roomTypeId
      }
      return null
    },
    setTravelerRoomType (val, traveler) {
      if (!parseInt(val)) {
        return
      }
      let placement = {
        roomTypeId: parseInt(val)
      }
      let index = this.$_.findIndex(traveler.placements, {'serviceId': parseInt(this.serviceId)})
      if (index !== -1) {
        traveler.placements[index].rooms.splice(0, 1, placement)
      } else {
        traveler.placements.push({
          serviceId: parseInt(this.serviceId),
          rooms: [placement]
        })
      }
    },
    getTravelerRoom (traveler) {
      let room = this.$_.find(traveler.placements, {'serviceId': parseInt(this.serviceId)})
      if (room) {
        return room.rooms[0].itemId
      }
      return null
    },
    setTravelerRoom (val, traveler) {
      if (!val) {
        return
      }
      let index = this.$_.findIndex(traveler.placements, {'serviceId': parseInt(this.serviceId)})
      if (index !== -1) {
        let serviceIndex = this.$_.findIndex(traveler.placements[index].rooms, {'roomTypeId': parseInt(val.serviceId)})
        if (serviceIndex !== -1) {
          this.$set(traveler.placements[index].rooms[serviceIndex], 'itemId', parseInt(val.itemId))
          this.$emit('roomsChosen')
        }
      } else {
        console.log('No room number chosen')
      }
    },
    getSelectedPlacementRoom (traveler) {
      if (!this.placements) {
        console.log('leeg')
        return
      }
      let roomTypeId = this.getTravelerRoomType(traveler)
      let rooms = []
      if (roomTypeId !== this.noneLabel) {
        this.placements.forEach((placement) => {
          if (parseInt(placement.id) === parseInt(roomTypeId)) {
            let group = {
              name: placement.name,
              items: []
            }
            for (let i = 1; i <= placement.amount; i++) {
              let item = {
                id: placement.id + '_' + i,
                serviceId: parseInt(placement.id),
                itemId: i,
                name: i
              }
              group.items.push(item)
            }
            rooms.push(group)
          }
        })
      }
      return rooms
    },
    travelerInfo (traveler) {
      let firstName = traveler.first_name || 'John'
      let lastName = traveler.last_name || 'Doe'
      let birthDate = traveler.birthdate || ''
      return firstName + ' ' + lastName + ' ' + birthDate
    }
  },
  watch: {
    items: {
      handler (val) {
        this.$emit('roomsChosen', val)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/details/AccommodationTravelers.vue